import CheckBox from "components/chexkbox";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function Noti() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <div className="noti-inf">
      {!pathname.includes("cancel") && (
        <>
          <h3 className="sub">{t("sb_ct_cmm")}</h3>
          <ul>
            <li>
              <h6>1.</h6> <h6>{t("txt_caution_1_mpg")}</h6>
            </li>
            <li>
              <h6>2.</h6>
              <h6>{t("txt_caution_2_mpg")}</h6>
            </li>
            <li>
              <h6>3.</h6>
              <h6>{t("txt_caution_3_mpg")}</h6>
            </li>
            <li>
              <h6>4.</h6>
              <h6>{t("txt_caution_4_mpg")}</h6>
            </li>
          </ul>
        </>
      )}
    </div>
  );
}
